import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Tabs } from '@mui/material';
import AppLinkTabComponent from 'components/mui/AppLinkTabComponent';

/**
 * Navigation Tabs Component - Reusable navigation tabs
 * @component
 * @param {Object} props - Component props
 * @returns {React.ReactElement} NavigationTabsComponent
 */
const NavigationTabsComponent = memo(({ 
  value, 
  onChange, 
  tabs = [], 
  ariaLabel = 'navigation tabs',
  ...props 
}) => {
  // Return/rendering
  return (
    <Tabs
      value={value}
      onChange={onChange}
      aria-label={ariaLabel}
      role="navigation"
      {...props}
    >
      {tabs.map((tab, index) => (
        <AppLinkTabComponent
          key={tab.href || index}
          label={tab.label}
          icon={tab.icon}
          href={tab.href}
          iconPosition={tab.iconPosition || 'start'}
          value={index}
        />
      ))}
    </Tabs>
  );
});

NavigationTabsComponent.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      icon: PropTypes.node,
      iconPosition: PropTypes.oneOf(['start', 'end', 'top', 'bottom']),
    })
  ).isRequired,
  ariaLabel: PropTypes.string,
  sx: PropTypes.object,
};

NavigationTabsComponent.displayName = 'NavigationTabsComponent';

export default NavigationTabsComponent;
